<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import ModalContentWrapper from "@/components/global-themed/ui/modals/ModalContentWrapper.vue";
import ModalHeading from "@/components/global-themed/ui/modals/ModalHeading.vue";
import ModalHeader from "@/components/global-themed/ui/modals/ModalHeader.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import ModalSubText from "@/components/global-themed/ui/modals/ModalSubText.vue";
import {useApiChangeLogs} from "@/composables/admin/useApiChangeLogs";

const {
  showDeleteWarningModal,
  deleteApiChangeLog,
  closeDeleteWarningModal
} = useApiChangeLogs();

const {mutate, isPending} = deleteApiChangeLog();
</script>

<template>
  <Teleport
    v-if="showDeleteWarningModal"
    to=".tailwind"
  >
    <BaseModal
      @close="closeDeleteWarningModal"
    >
      <ModalContentWrapper>
        <ModalHeader>
          <ModalHeading>Are you sure?</ModalHeading>
          <ModalSubText>You are about to delete the API Changelog, which will also remove it from the RSS feed</ModalSubText>
        </ModalHeader>
        <div class="tw-flex tw-items-center tw-gap-4 tw-justify-end tw-w-full">
          <DefaultButton
            variant="danger"
            :loading="isPending"
            :disabled="isPending"
            @click="mutate"
          >
            Delete
          </DefaultButton>

          <DefaultButton
            variant="primary"
            :loading="isPending"
            :disabled="isPending"
            @click="closeDeleteWarningModal"
          >
            Cancel
          </DefaultButton>
        </div>
      </ModalContentWrapper>
    </BaseModal>
  </Teleport>
</template>
